export default "__VITE_ASSET__DuwkhZ2w__"